import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import LogoMark from "./LogoMark";
import { scrollToSection } from "../lib/scroll";
import { EASE } from "./Reveal";

const LINKS = [
    { label: "Latest Project", hash: "#latest-project", id: "nav-link-latest-project" },
    { label: "Money Talks", hash: "#money-talks", id: "nav-link-money-talks" },
    { label: "Case Files", hash: "#case-files", id: "nav-link-case-files" },
    { label: "New Business", hash: "#new-business", id: "nav-link-new-business" },
];

export default function Nav() {
    const navigate = useNavigate();

    const go = (e, hash) => {
        e.preventDefault();
        if (document.querySelector(hash)) {
            scrollToSection(hash);
        } else {
            navigate("/");
            setTimeout(() => scrollToSection(hash), 120);
        }
    };

    return (
        <motion.header
            initial={{ y: -24, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: EASE, delay: 1.15 }}
            className="fixed inset-x-0 top-0 z-50 bg-black/85 text-white backdrop-blur-md"
        >
            <nav className="flex items-center justify-between px-5 py-4 md:px-8 md:py-5">
                <a
                    href="#top"
                    data-testid="nav-home-link"
                    onClick={(e) => go(e, "#top")}
                    className="flex items-center gap-2.5"
                >
                    <LogoMark className="h-5 w-5" bg={null} fg="#FFFFFF" />
                    <span className="font-logo text-lg font-bold italic leading-none tracking-tight md:text-xl">
                        Money Mac Media
                        <sup className="align-super text-[0.5em]">®</sup>
                    </span>
                </a>
                <div className="flex items-center gap-4 md:gap-5 lg:gap-7">
                    <div className="hidden items-center gap-4 font-mono text-[11px] uppercase tracking-[0.18em] md:flex lg:gap-7">
                        {LINKS.map((l) => (
                            <a
                                key={l.hash}
                                data-testid={l.id}
                                href={l.hash}
                                onClick={(e) => go(e, l.hash)}
                                className="transition-opacity duration-300 hover:opacity-50"
                            >
                                {l.label}
                            </a>
                        ))}
                    </div>
                    <a
                        href="#new-business"
                        data-testid="nav-inquire-button"
                        onClick={(e) => go(e, "#new-business")}
                        className="border border-white/70 px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors duration-300 hover:bg-white hover:text-black"
                    >
                        Inquire
                    </a>
                </div>
            </nav>
        </motion.header>
    );
}
